var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('heading',[_c('h2',[_vm._v(_vm._s(_vm.$t("archived-payments")))]),_c('p',[_vm._v(_vm._s(_vm.$t("payments-.sub-heading-archived")))])]),_c('filtered-table',{attrs:{"hide-status":"","baseFilters":{ status: ['failed', 'paid'] }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }